<grid-list class="{style.gridList} {opts.class}">
  <yield />

  <script>
   import style from './grid-list.scss';
   this.style = style;
  </script>
</grid-list>
